import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import VideoSelection from "./VideoSelection";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";

export default ({ closeVideoSelection, onVideoSelect }) => {
  // get User media data
  const GET_MEDIA_DATA = gql`
    query GetMediaData {
      mediaData {
        id
        created_at
        video_id
        original_name
        status
      }
    }
  `;

  const { data, error } = useQuery(GET_MEDIA_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Fetching media data error", error);
    captureException(error);
  }

  console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="250px" />
        </LoadingBox>
      )}
      {data && (
        <VideoSelection
          data={data}
          closeVideoSelection={closeVideoSelection}
          onVideoSelect={onVideoSelect}
        />
      )}
    </>
  );
};
